module.exports = "/_next/static/images/3f3d0b7b11bff408b2bc50f519140d6e-cajitas-right-mobile.jpg.webp";